import { useEffect, useState } from 'react'
import { getMe, type MeResponse } from '../api'

export function Dashboard() {
  const [me, setMe] = useState<MeResponse | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    let cancelled = false
    getMe()
      .then((data) => !cancelled && setMe(data))
      .catch((e) => !cancelled && setError(e instanceof Error ? e.message : String(e)))
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <div>
      <h1>Översikt</h1>
      <p className="muted">
        Kunder och leveransområden är på plats. Övriga moduler (produkter, ordrar,
        fakturering, ringlistor, rapporter) byggs i kommande iterationer enligt förstudien.
      </p>

      <section className="card">
        <h2>Inloggad användare (verifierad mot API)</h2>
        {error && <p className="error">Kunde inte hämta /api/v1/me: {error}</p>}
        {!error && !me && <p className="muted">Hämtar…</p>}
        {me && (
          <dl className="kv">
            <dt>E-post</dt><dd>{me.email ?? '—'}</dd>
            <dt>Tenant</dt><dd>{me.tenant ?? '—'}</dd>
            <dt>Subject</dt><dd><code>{me.subject ?? '—'}</code></dd>
            <dt>Roller</dt>
            <dd>{me.roles.length ? me.roles.map((r) => <span key={r} className="badge">{r}</span>) : '—'}</dd>
          </dl>
        )}
      </section>
    </div>
  )
}
